export default __webpack_public_path__ + "static/media/energymanagement.b8cf2331.webp";